// Customizable Area Start
import React from "react";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { IBlock } from "../../../framework/src/IBlock";
import { runEngine } from "../../../framework/src/RunEngine";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { CaptionViews, NewPostCreationSteps } from "./enums";
import { File, Poll } from "./types";

export const configJSON = require("./config");

export type Props = {
  classes: any;
  files: File[];
  poll: Poll;
  caption: string;
  view: CaptionViews;
  setStep: (step: NewPostCreationSteps) => void;
  closeModal: () => void;
  setCaption: (caption: string) => void;
  setPollQuestion: (question: string) => void;
  setPollAnswer1: (answer: string) => void;
  setPollAnswer2: (answer: string) => void;
  setCaptionView: (view: CaptionViews) => void;
};

interface S {
  currentFile: number;
  touchStartX: number;
  touchStartY: number;
}

interface SS {
  navigation: any;
  stepType: NewPostCreationSteps;
}

export default class NewPostAddCaptionController extends BlockComponent<
  Props,
  S,
  SS
> {

  constructor(props: Props) {
    super(props);
    this.subScribedMessages = [getName(MessageEnum.RestAPIResponceMessage)];

    this.state = {
      currentFile: 0,
      touchStartX: 0,
      touchStartY: 0,
    };

    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  setCurrentFile = (fileIndex: number) => {
    if (fileIndex !== this.state.currentFile && fileIndex >= 0 && fileIndex < this.props.files.length) {
      this.setState({
        currentFile: fileIndex,
      });
    }
  };

  handleTouchStart = (e: React.TouchEvent) => {
    const touch = e.touches[0];
    this.setState({
      touchStartX: touch.clientX,
      touchStartY: touch.clientY,
    });
  };

  handleTouchEnd = (e: React.TouchEvent) => {
    const touch = e.changedTouches[0];
    const touchEndX = touch.clientX;
    const touchEndY = touch.clientY;
    const deltaX = touchEndX - this.state.touchStartX;
    const deltaY = touchEndY - this.state.touchStartY;

    // Only process horizontal swipes (ignore vertical scrolling)
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
      if (deltaX > 0) {
        // Swipe right - go to previous image
        this.setCurrentFile(this.state.currentFile - 1);
      } else {
        // Swipe left - go to next image
        this.setCurrentFile(this.state.currentFile + 1);
      }
    }
  };

  handleMouseDown = (e: React.MouseEvent) => {
    this.setState({
      touchStartX: e.clientX,
      touchStartY: e.clientY,
    });
  };

  handleMouseUp = (e: React.MouseEvent) => {
    const deltaX = e.clientX - this.state.touchStartX;
    const deltaY = e.clientY - this.state.touchStartY;

    // Only process horizontal drags (ignore vertical scrolling)
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
      if (deltaX > 0) {
        // Drag right - go to previous image
        this.setCurrentFile(this.state.currentFile - 1);
      } else {
        // Drag left - go to next image
        this.setCurrentFile(this.state.currentFile + 1);
      }
    }
  };
}
// Customizable Area End
